import React, { useEffect, useState } from "react";
import baseUrl from "../../api/universalApi";
import { useSelector } from "react-redux";

const ViewContract = () => {
  const [contract, setContract] = useState(null);

  const user = useSelector((state) => state.auth?.authData?.user);
  console.log("User Data:", user);
  const useLocation = () => {
    const { pathname } = window.location;
    const pathParts = pathname.split("/");
    return {
      pathname,
      campaignId: pathParts[pathParts.length - 1],
    };
  };

  const location = useLocation();

  const fetchContractDetails = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/agreement/getAgreement/${location.campaignId}`
      );
      const data = await response.json();
      setContract(data);
    } catch (error) {
      console.error("Error fetching contract details:", error);
    }
  };

  useEffect(() => {
    fetchContractDetails();
  }, []);

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString() : "--";

  return (

    <>
    <div className="w-full bg-gray-200 mx-auto p-6 space-y-6">
      <div className="bg-white rounded shadow p-4 w-full">
        <h2 className="text-lg font-semibold mb-4">Contract Details</h2>
       

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <span className="font-medium">Publish Date:</span>{" "}
            <span className="text-gray-700">
              {formatDate(contract?.publish_date)}
            </span>
          </div>
          <div>
            <span className="font-medium">Final Amount:</span>{" "}
            <span className="text-gray-700">
              {contract?.amount || "--"}
            </span>
          </div>
          <div>
            <span className="font-medium">Company Name:</span>{" "}
            <span className="text-gray-700">
              {contract?.company || "--"}
            </span>
          </div>
          <div>
            <span className="font-medium">Collaterals/Deliverables:</span>{" "}
            <span className="text-gray-700">
              {contract?.deliverables || "--"}
            </span>
          </div>
          <div>
            <span className="font-medium">Payment Type:</span>{" "}
            <span className="text-gray-700">
              {contract?.paymentType || "--"}
            </span>
          </div>
          <div>
            <span className="font-medium">Start Date:</span>{" "}
            <span className="text-gray-700">
              {formatDate(contract?.start_date)}
            </span>
          </div>
          <div>
            <span className="font-medium">End Date:</span>{" "}
            <span className="text-gray-700">
              {formatDate(contract?.end_date)}
            </span>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-lg font-semibold">Signatures</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <span className="font-medium">Creator Signature:</span>{" "}
              <span className="text-gray-700">
                {contract?.creator_signature || "--"}
              </span>
            </div>
            <div>
              <span className="font-medium">
                Brand Representative Signature:
              </span>{" "}
              <span className="text-gray-700">
                {contract?.rep_signature || "--"}
              </span>
            </div>
            <div>
              <span className="font-medium">Brand Representative Email:</span>{" "}
              <span className="text-gray-700">
                {contract?.rep_email || "--"}
              </span>
            </div>
          </div>
        </div>


      </div>
    </div>
    
    <div>
      {user?.userType === "Brand" && (

        <>
        <div>

        </div>
        
        </>
      )}

    </div>
    
    
    </>
  );
};

export default ViewContract;
